import { Footer } from 'antd/lib/layout/layout'
import { Link } from 'react-router-dom'

const FooterContainer = ({ availableDocuments = [''] }) => {
  const Links = availableDocuments.map((document, idx) => {
    const element = document.replace(/-/g, ' ')

    return (
      <Link className='Link' to={document} key={idx} onClick={() => { window.location = document }}>
        <li>
          {element}
        </li>
      </Link>
    )
  })

  return (
    <Footer className='Footer'>
      <ul>
        {Links}
      </ul>
    </Footer>
  )
}

export default FooterContainer
